import {
  IFlightCardTranslations,
  IPriceSummaryTranslations,
} from "@thekilroygroup/shared-ui";
import { ITranslationsData } from "hooks/translations.interfaces";

export const getBaggageInfoTranslations = (
  dataTranslations: ITranslationsData,
) => {
  return {
    title: dataTranslations.baggageSummary.title,
    details: dataTranslations.baggageSummary.details,
    baggageDetails: dataTranslations.baggageSummary.baggageDetails,
    departureFlight: dataTranslations.baggageSummary.departureFlight,
    returnFlight: dataTranslations.baggageSummary.returnFlight,
    flight: dataTranslations.baggageSummary.flight,
    baggageTypes: dataTranslations.flightCard.baggage.baggageTypes,
    passengerTypes: dataTranslations.passengerTypes,
  };
};

export const getFlightCardTranslations = (
  dataTranslations: ITranslationsData,
) => {
  const flightCardTranslations: IFlightCardTranslations = {
    addBaggage: dataTranslations.flightCard.addBaggage,
    addBaggageButton: dataTranslations.flightCard.addBaggageButton,
    baggage: dataTranslations.flightCard.baggage,
    chooseButton: dataTranslations.flightCard.chooseButton,
    detailsButton: dataTranslations.flightCard.detailsButton,
    nonBaggageButton: dataTranslations.flightCard.nonBaggageButton,
    person: dataTranslations.flightCard.person,
    flightDetailsTranslations: dataTranslations.flightCard.details,
    ticketTagsTranslations: dataTranslations.flightCard.ticketTags,
    airportTransferNotification:
      dataTranslations.searchResults.airportTransferNotification,
    baggageInfoTranslations: getBaggageInfoTranslations(dataTranslations),
    bookingTranslations: dataTranslations.booking,
    cabinClassesTranslations: dataTranslations.cabinClasses,
    itinerarySummaryTranslations: dataTranslations.flightSummary,
    locale: dataTranslations.locale,
    mealInfoTranslations: {
      ...dataTranslations.mealInfo,
      mealCodesTypes: dataTranslations.mealCodesTypes,
    },
    pageTitle: dataTranslations.pageTitle,
    passengerTypesMap: dataTranslations.passengerTypesMap,
    priceInformationTranslations: dataTranslations.priceInformation,
    socialShareTranslations: dataTranslations.socialShare,
    ticketRulesTranslations: dataTranslations.ticketRules,
    timeLabelsTranslations: dataTranslations.timeLabels,
    totalPrice: dataTranslations.paymentMethod.totalPrice,
    perPerson: dataTranslations.paymentMethod.perPerson,
    stopsTranslations: dataTranslations.searchResults.stops,
  };
  return flightCardTranslations;
};

export const getPriceSummaryTranslations = (
  dataTranslations: ITranslationsData,
) => {
  const priceSummaryTranslations: IPriceSummaryTranslations = {
    locale: dataTranslations.locale,
    pricesFrom: dataTranslations.priceSummary.pricesFrom,
    taxAndSurcharges: dataTranslations.priceSummary.taxAndSurcharges,
    passengerTypes: dataTranslations.passengerTypes,
  };
  return priceSummaryTranslations;
};
